'use client';

import { useState } from 'react';
import { FormattedMessage } from '@alltrails/shared/react-intl';
import Button from '@alltrails/shared/denali/components/Button';
import logSignUpScreenContinueButtonTapped from '@alltrails/analytics/events/logSignUpScreenContinueButtonTapped';
import SignUpScreenContinueButtonType from '@alltrails/analytics/enums/SignUpScreenContinueButtonType';
import AppQrCodeModal from '../AppQrCodeModal';
import qrCodeImgSrc from './explore-qr-code.webp';

const GetTheAppButton = () => {
  const [showGetTheAppModal, setShowGetTheAppModal] = useState(false);

  return (
    <>
      <Button
        onClick={() => {
          logSignUpScreenContinueButtonTapped({ signup_screen_continue_button_type: SignUpScreenContinueButtonType.ContinueInApp });
          setShowGetTheAppModal(true);
        }}
        size="sm"
        text={<FormattedMessage defaultMessage="Get the app" />}
        variant="accent"
      />
      <AppQrCodeModal
        isOpen={showGetTheAppModal}
        onRequestClose={() => {
          setShowGetTheAppModal(false);
        }}
        qrCode={qrCodeImgSrc}
        subtitleDesktop={<FormattedMessage defaultMessage="Scan the QR code to open the AllTrails app" />}
        subtitleMobile={' '}
        title={<FormattedMessage defaultMessage="Open in the app" />}
        variant="explore"
      />
    </>
  );
};

export default GetTheAppButton;
